import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from '@ramonak/react-progress-bar';
import { toast } from 'react-toastify';
import { formatISO } from 'date-fns';
import { ThemeContext } from 'styled-components';
import { useParams } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import {
  FiPlay,
  FiInfo,
  FiLink,
  FiVideoOff,
  FiGitMerge,
  FiVideo,
  FiThumbsDown,
  FiUploadCloud,
  FiRadio,
} from 'react-icons/fi';

import { useModal } from 'hooks/modal';
import { IRootState } from 'store/modules/rootReducer';
import { Avaliacaoeng, Permissao, Role } from 'utils/variables';
import AppError from 'utils/AppError';
import api from 'services/api';
import { IMidiaInfoItem, midiainfo } from '../../utils/midiainfo/index';
import { show } from 'store/modules/dialog/actions';

import Timeline, { ITimelineItem } from 'components/Timeline';
import Flag from 'components/Flag';
import Field from 'components/Field';
import PlayerBaixa from 'components/PlayerBaixa';
import Button from 'components/Button';
import Radio from 'components/Radio';
import Avatar from 'components/Avatar';

import {
  Container,
  Content,
  Header,
  GeneralData,
  GeneralDataHeader,
  Info,
  Avaliacao,
  EnviaExibidor,
  InfoAvaliacao,
  Engenharia,
  MidiaInfo,
  TimelineData,
  Table,
} from './styles';
import { Emissora, EnviaExibidor as IEnviaExibidor } from 'pages/@types';
import { Form } from '@unform/web';
import Tooltip from 'components/Tooltip';
import { usePermit } from 'utils/hooks/usePermit';

interface IComercialItem {
  id: number;
  titulo: string;
  codmaterial: number;
  duracao: number;
  ptovenda: string;
  midia?: IMidiaItem;
  categoria: 'comercial' | 'patrocinio' | 'promo' | 'base';
  statusdownload:
    | 'pendente'
    | 'emAndamento'
    | 'entregue'
    | 'reenvio'
    | 'indisponivel'
    | 'erro';
  formatted_created_at: string;
  player?: {
    id: number;
    nome: string;
  };
  cliente?: {
    id: number;
    mnemonico: string;
  };
  produtora?: {
    id: number;
    nome: string;
  };
  agencia?: { id: number; mnemonico: string };
}

interface IMidiaItem {
  id: number;
  avaliacaoeng: 'pendente' | 'aprovado' | 'ressalva' | 'reprovado';
  formatted_checked_at?: string;
  formatted_created_at?: string;
  thumbnail_url?: string;
  preview_url?: string;
  loudness?: string;
  obseng?: string;
  statusbaixa?: 'pendente' | 'processando' | 'processado' | 'erro' | 'NA';
  statuspreavaliacao8ch?:
    | 'pendente'
    | 'aprovado'
    | 'ressalva'
    | 'reprovado'
    | 'NA';
  statuspreavaliacao?:
    | 'pendente'
    | 'aprovado'
    | 'ressalva'
    | 'reprovado'
    | 'NA';
  categoria: string;
  avaliador?: {
    id: number;
    nome: string;
    avatar_url?: string;
  };
}
interface MXFFile extends File {
  progress: number;
  uploaded: boolean;
  error: boolean;
}
interface IHistoricoProps {
  comercial: IComercialItem;
  midia?: IMidiaItem | null;
  midiainfo?: {
    midiainfo?: IMidiaInfoItem;
    midiainfo8ch?: IMidiaInfoItem;
  } | null;
  timeline: ITimelineItem[];
  envios: IEnviaExibidor[];
}

const Historico: React.FC = () => {
  const [emissoras, setEmissoras] = useState<Emissora[]>([]);
  const [loadingEmissoras, setLoadingEmissoras] = useState(false);
  const [historico, setHistorico] = useState<IHistoricoProps>({
    comercial: {} as IComercialItem,
    timeline: [],
    envios: [],
  });

  const [uploadProgress, setUploadProgress] = useState(0);
  const [mxfFile, setMxfFile] = useState<MXFFile[]>([]);
  const [loading, setLoading] = useState(true);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  const { showModal, hideModal, updateModal, modalData } = useModal();

  const hasOperacaoRemota = usePermit([], [Permissao.OPERACAOREMOTA]);
  const hasPRE = usePermit([Role.OPEC, Role.ENG], []);

  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );
  // Get params
  const { midiaId } = useParams<{ midiaId: string }>();

  const { profile } = useSelector((state: IRootState) => state.usuario) as any;
  // theme color
  const themeContext = useContext(ThemeContext);

  // functions
  function handleMidiaInfoDialog(processed: boolean) {
    if (historico.midiainfo && historico.midia) {
      if (
        processed &&
        historico.midiainfo.midiainfo &&
        historico.midia.statuspreavaliacao
      ) {
        const options = midiainfo(
          historico.midia.statuspreavaliacao,
          historico.midiainfo.midiainfo,
        );
        dispatch(show(options));
      } else if (
        historico.midiainfo.midiainfo8ch &&
        historico.midia.statuspreavaliacao8ch
      ) {
        const options = midiainfo(
          historico.midia.statuspreavaliacao8ch,
          historico.midiainfo.midiainfo8ch,
        );
        dispatch(show(options));
      }
    }
  }

  function copyToClipboard(text: string) {
    const dummy = document.createElement('textarea');
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    // Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    toast.success('Link copiado na a área de transferência');
  }
  // useCallbacks
  const handlePlayer = useCallback(
    (previewurl?: string) => {
      console.log(previewurl);
      if (previewurl) {
        setPlayer({
          open: !player.open,
          midia_url: previewurl,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );

  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const handleDesvinculaMidia = useCallback(
    (id: number) => {
      showModal({
        title: 'ATENÇÃO',
        component: <p>Desvincular Midia?</p>,
        callback: async () => {
          updateModal({ ...modalData, loading: true });
          try {
            await api
              .put(`/comerciaists/${id}`, { resetmidia: true })
              .then(() => {
                setHistorico(prevState => ({
                  ...prevState,
                  midia: null,
                  midiainfo: null,
                  comercial: {
                    ...prevState.comercial,
                    statusdownload: 'indisponivel',
                  },
                  envios: prevState.envios.map(e => ({
                    ...e,
                    statusgeral: {
                      order: 9,
                      nome: 'INDISPONIVEL',
                      type: 'indisponivel',
                      info: 'Comercial não foi baixado pela Entrega Digital',
                    },
                  })),
                  timeline: [
                    ...prevState.timeline,
                    {
                      mensagem: `Midia ${prevState.comercial?.midia?.id} desvinculada`,
                      _id: `_id`,
                      tipo: 'resetmidia',
                      createdAt: formatISO(new Date()),
                    },
                  ],
                }));
                toast.success('Midia Desvinculada');
              });
            hideModal();
          } catch (error) {
            if (error instanceof Error) toast.error(error.message);
            else {
              const appError = error as AppError;
              toast.error(appError.message);
            }
          } finally {
            // updateModal({ ...modalData, loading: true });
          }
        },
      });
    },
    [hideModal, modalData, showModal, updateModal],
  );

  const handleReavaliar = useCallback(() => {
    if (historico.comercial && historico.midia) {
      const option = {
        type: 'question',
        text: `Solicitar reavaliação de ${historico.comercial.titulo}?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          action: 'reavaliar',
          data: {
            avaliacaoeng: Avaliacaoeng.PENDENTE,
          },
          url: `/midias/${historico.midia.id}`,
          method: api.put,
        },
        haveCallback: true,
        successMessage: 'Confirmado execução!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(option));
    } else toast.error('Erro inesperado');
  }, [dispatch, historico.comercial, historico.midia]);

  const handleReprova = useCallback(() => {
    if (historico.comercial && historico.midia) {
      const options = {
        type: 'question',
        confirmButtonText: 'CONFIRMAR',
        callback: {
          action: 'reprova',
          url: `/midias/${historico.midia.id}`,
          method: api.put,
          data: {
            avaliacaoeng: 'reprovado',
            categoria: historico.midia.categoria,
          },
        },
        text: `Confirmar REPROVA de ${historico.comercial.titulo}?`,
        inputType: 'text',
        maxlength: '800',
        haveCallback: true,
        successMessage: 'Mídia avaliada com sucesso!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };

      dispatch(show(options));
    } else toast.error('Erro inesperado');
  }, [dispatch, historico]);

  useEffect(() => {
    if (callbackDialog && callbackDialog.success) {
      if (callbackDialog.success.action === 'reprova') {
        setHistorico(prevState => ({
          ...prevState,
          ...(prevState.midia && {
            midia: {
              ...prevState.midia,
              avaliacaoeng: 'reprovado',
              obseng: callbackDialog.success.data.obseng,
              avaliador: {
                id: profile.id,
                avatar_url: profile.avatar_url,
                nome: profile.nome,
              },
            },
          }),
        }));
      } else if (callbackDialog.success.action === 'reavaliar') {
        setHistorico(prevState => {
          if (prevState.midia) {
            delete prevState.midia.avaliador;
            delete prevState.midia.obseng;
          }
          return {
            ...prevState,
            ...(prevState.midia && {
              midia: {
                ...prevState.midia,
                avaliacaoeng: 'pendente',
              },
            }),
          };
        });
      } else if (callbackDialog.success.action === 'pre') {
        const novosEnvios = callbackDialog.success.data.enviaexibidor.filter(
          envio => envio.emissora !== 1,
        );

        setHistorico(prevState => ({
          ...prevState,
          envios: [...prevState.envios, ...novosEnvios],
        }));
      }
    }
  }, [callbackDialog, profile.avatar_url, profile.id, profile.nome]);

  const handleSubmit = useCallback(
    async data => {
      try {
        if (data.emissoraorigem && data.emissoradestino) {
          const response = await api.post(
            `/operacaoremota/comercial/${historico.comercial.id}`,
            {
              emissoraorigem: Number(data.emissoraorigem),
              emissoradestino: Number(data.emissoradestino),
            },
          );
          if (response && response.data) {
            const novoEnvio = {
              ...response.data,
              statusgeral: {
                order: 16,
                nome: 'FILA ENVIO EXIBIDOR',
                type: 'fila_envio',
                info: 'Midia na fila para envio ao exibidor',
              },
            };
            setHistorico(prevState => ({
              ...prevState,
              envios: [...prevState.envios, novoEnvio],
            }));
            toast.success('Envios criados');
          } else toast.error('Falha ao criar envios');
          hideModal();
        } else toast.error('Informe as emissoras de origem e destino');
      } catch (err) {
        console.log(err);
        if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      }
    },
    [hideModal, historico.comercial.id],
  );

  const handleSinalizarPRE = useCallback(
    async comercial => {
      const optionBase = {
        type: 'question',
        contentHTML: `Confirma PRE para ${comercial.titulo}?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/comerciaists/${comercial.id}`,
          method: api.put,
          action: 'pre',
          data: { pre: true },
        },
        haveCallback: true,
        successMessage: `Envios PRE criados!`,
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };

      dispatch(show(optionBase));
    },
    [dispatch],
  );

  const handleOperacaoRemota = useCallback(() => {
    if (emissoras && emissoras.length > 0) {
      const emissorasOrigem = emissoras
        .filter(e => historico.envios?.map(e => e.emissora.id).includes(e.id))
        .map(e => ({ id: e.id, label: e.nome }));
      const emissorasDestino = emissoras
        .filter(e => !historico.envios?.map(e => e.emissora.id).includes(e.id))
        .map(e => ({ id: e.id, label: e.nome }));
      showModal({
        title: 'Selecionar a emissora',
        component: (
          <Form onSubmit={handleSubmit}>
            <h3 style={{ marginBottom: '1rem' }}>Emissora Origem</h3>
            <Radio
              name="emissoraorigem"
              options={emissorasOrigem}
              disabled={loading || loadingEmissoras}
            />
            <h3 style={{ margin: '3rem 0 1rem 0' }}>Emissora Destino</h3>
            <Radio
              name="emissoradestino"
              options={emissorasDestino}
              disabled={loading || loadingEmissoras}
            />
            <Button type="submit" color="primary">
              CONFIRMAR
            </Button>
          </Form>
        ),
        width: '50vw',
      });
    } else toast.error('Falha ao carregar emissoras');
  }, [
    emissoras,
    handleSubmit,
    historico.envios,
    loading,
    loadingEmissoras,
    showModal,
  ]);

  const handleUpload = useCallback(async (comercialId: number) => {
    // crio um elemento input para receber o arquivo, com type, accpet, multiple.
    // quando o input muda no onchange, pego o arquivo e verifico o tipo se é mxf e senao for mostro um erro.
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.mxf,.MXF';
    input.multiple = false;

    input.onchange = async (e: any) => {
      // contém o primeiro (e único, já que multiple = false) arquivo selecionado
      const file = e.target.files[0];
      if (file) {
        // if (!file.name.toLowerCase().endsWith('.mxf')) {
        //   toast.error('Apenas arquivos MXF são permitidos');
        //   return;
        // }
        // Criar arquivo com propriedades de progresso
        // usando Object.assign() para estender o objeto File nativo com propriedades customizadas
        const mxfFileWithProgress: MXFFile = Object.assign(file, {
          progress: 0, // Progresso do upload (0-100)
          uploaded: false, // Se o upload foi concluído
          error: false, // Se houve erro no upload
        });

        // Usa array porque pode haver múltiplos arquivos (embora aqui seja apenas um)
        setMxfFile([mxfFileWithProgress]);

        const formData = new FormData();
        formData.append('file', file);
        formData.append('comercial_id', comercialId.toString());

        try {
          const response = await api.post(`/midias`, formData, {
            timeout: 300000, // 5 minutos
            // monta a barra de porcentagem
            onUploadProgress: e => {
              const progress = e.total
                ? Math.round((e.loaded * 100) / e.total)
                : 0;
              setUploadProgress(progress);
            },
          });
          if (response?.data?.midia) {
            setHistorico(prevState => ({
              ...prevState,
              comercial: {
                ...prevState.comercial,
                statusdownload: 'entregue',
              },
              midia: response.data.midia,
              envios: prevState.envios.map(e => ({
                ...e,
                statusgeral: {
                  order: 14,
                  nome: 'PENDENTE ENG',
                  type: 'pendente',
                  info: 'Midia aguardando avaliação da engenharia',
                },
              })),
            }));
            toast.success('Mídia carregada com sucesso');

            // marca upload concluído quando chega a 100%
            setMxfFile(prevFiles =>
              prevFiles.map(f =>
                f === mxfFileWithProgress
                  ? { ...f, uploaded: true, progress: 100 }
                  : f,
              ),
            );
            // Limpar arquivo após 2 segundos
            setTimeout(() => {
              setMxfFile([]);
            }, 2000);
          }
        } catch (error) {
          if (error instanceof Error) {
            toast.error(error.message);
          } else {
            const appError = error as AppError;
            if (appError.message === 'erro') {
              toast.error('Apenas arquivos MXF são permitidos');
            } else {
              toast.error('Erro ao fazer upload do arquivo');
            }
          }

          // Limpar arquivo com erro após 3 segundos
          setTimeout(() => {
            setMxfFile([]);
          }, 3000);
        }
      }
    };
    input.click();
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function loadEmissoras() {
      setLoadingEmissoras(true);
      try {
        const response = await api.get('/emissoras');
        if (response && response.data) {
          setEmissoras(response.data);
        } else toast.error('Falha de comunicação com o sistema');
      } catch (error) {
        if (error instanceof Error) {
          toast.error(error.message);
        } else {
          const appError = error as AppError;
          toast.error(appError.message);
        }
      } finally {
        setLoadingEmissoras(false);
      }
    }
    loadEmissoras();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);

    setHistorico({
      comercial: {} as IComercialItem,
      timeline: [],
      envios: [],
    });
    api
      .get<IHistoricoProps>(`/comerciaists/historico/${midiaId}`, {
        signal: controller.signal,
      })
      .then(response => {
        setHistorico(response.data);
      })
      .catch(error => {
        toast.error('Falha ao resgatar histórico');
        console.log(error);
      })
      .finally(() => setLoading(false));
    return () => {
      controller.abort();
    };
  }, [midiaId]);

  return (
    <Container>
      <Header>
        <h2>
          {historico?.comercial.titulo || <Skeleton width={300} height={20} />}
        </h2>
        <span>
          {historico?.comercial.formatted_created_at || (
            <Skeleton width={200} />
          )}
        </span>
        {/* Criado em 23/06/2021 às 16:49 */}
      </Header>
      <Content>
        <GeneralData>
          <GeneralDataHeader>
            <h3>Informações Gerais</h3>
            <Button
              disabled={!historico.comercial || loading || !hasPRE}
              fill
              color="font"
              size="xsm"
              round
              tooltip="SINALIZAR PRE"
              onClick={() => handleSinalizarPRE(historico.comercial)}
            >
              <FiRadio />
            </Button>
          </GeneralDataHeader>
          <div>
            <Info>
              <li>
                <p>Duração:</p>
                <strong>
                  <Field
                    tag="strong"
                    loading={loading}
                    value={historico?.comercial.duracao}
                    width={80}
                  />
                </strong>
              </li>
              <li>
                <p>Código do Material:</p>
                <strong>
                  {historico?.comercial.codmaterial || (
                    <Skeleton width={60} height={15} />
                  )}
                </strong>
              </li>
              <li>
                <p>Ponto de Venda:</p>
                <strong>
                  <Field
                    tag="strong"
                    loading={loading}
                    value={historico?.comercial.ptovenda}
                    width={50}
                  />
                </strong>
              </li>
              <li>
                <p>Categoria:</p>
                <strong>
                  <Field
                    tag="strong"
                    loading={loading}
                    value={historico?.comercial?.categoria}
                    width={120}
                  />
                </strong>
              </li>
            </Info>

            <Info>
              <li>
                <p>Status Download:</p>

                <strong
                  style={{
                    textTransform: 'capitalize',
                    color:
                      themeContext?.flag[
                        historico?.comercial?.statusdownload || 'indisponivel'
                      ],
                  }}
                >
                  {historico?.comercial?.statusdownload || (
                    <Skeleton width={90} height={15} />
                  )}
                  {historico.comercial.player &&
                    ` | ${historico.comercial.player.nome}`}
                </strong>
              </li>
              <li>
                <p>Cliente:</p>
                <Field
                  tag="strong"
                  loading={loading}
                  value={historico?.comercial?.cliente?.mnemonico}
                />
              </li>
              <li>
                <p>Agência:</p>
                <strong>
                  <Field
                    tag="strong"
                    loading={loading}
                    value={historico?.comercial?.agencia?.mnemonico}
                    width={80}
                  />
                </strong>
              </li>
              <li>
                <p>Produtora:</p>
                <strong>
                  <Field
                    tag="strong"
                    loading={loading}
                    value={historico?.comercial?.produtora?.nome}
                    width={80}
                  />
                </strong>
              </li>
            </Info>
          </div>
          <Engenharia>
            <Avaliacao status={historico?.midia?.avaliacaoeng || 'pendente'}>
              <GeneralDataHeader>
                <h3>Avaliação da Engenharia</h3>
                {historico.midia &&
                  historico.midia.avaliacaoeng === Avaliacaoeng.REPROVADO && (
                    <Button
                      disabled={
                        !(
                          profile.role === Role.ADMIN ||
                          (profile.role === Role.ENG &&
                            profile.emissoras?.some(
                              (e: { sigla: string }) => e.sigla === 'CUR',
                            ))
                        )
                      }
                      fill
                      color="font"
                      size="xsm"
                      round
                      tooltip="REAVALIAR MÍDIA"
                      onClick={() => handleReavaliar()}
                    >
                      <FiVideo />
                    </Button>
                  )}
                {historico.midia &&
                  historico.midia.avaliacaoeng === Avaliacaoeng.PENDENTE && (
                    <Button
                      disabled={
                        !(
                          profile.role === Role.ADMIN ||
                          (profile.role === Role.ENG &&
                            profile.emissoras?.some(
                              (e: { sigla: string }) => e.sigla === 'CUR',
                            ))
                        )
                      }
                      fill
                      color="font"
                      size="xsm"
                      round
                      tooltip="REPROVAR MÍDIA"
                      onClick={handleReprova}
                    >
                      <FiThumbsDown />
                    </Button>
                  )}
              </GeneralDataHeader>
              <div>
                <Avatar
                  size="56"
                  round
                  name={historico?.midia?.avaliador?.nome || 'N A'}
                  color={historico?.midia?.avaliador?.nome ? '' : 'grey'}
                  src={historico?.midia?.avaliador?.avatar_url}
                />
                <InfoAvaliacao
                  status={historico?.midia?.avaliacaoeng || 'pendente'}
                >
                  <div>
                    <Field
                      width={120}
                      height={20}
                      tag="h4"
                      value={historico?.midia?.avaliacaoeng}
                      error="Pendente"
                    />

                    <Field
                      width={120}
                      height={20}
                      tag="span"
                      value={historico?.midia?.formatted_checked_at}
                      error="-"
                    />
                  </div>

                  <Field
                    count={3}
                    width={600}
                    loading={loading}
                    tag="p"
                    value={historico.midia?.obseng}
                    error={
                      historico?.midia?.avaliacaoeng &&
                      historico.midia.avaliacaoeng
                        ? 'Nenhuma observação anotada pela engenharia'
                        : 'Aguardando avalição da engenharia'
                    }
                  />
                </InfoAvaliacao>
              </div>
            </Avaliacao>
            <MidiaInfo>
              <GeneralDataHeader>
                <h3>Dados da Mídia</h3>
                {historico.midia ? (
                  <Button
                    disabled={
                      !historico.midia ||
                      historico.midia.avaliacaoeng === Avaliacaoeng.APROVADO ||
                      historico.midia.avaliacaoeng === Avaliacaoeng.RESSALVA ||
                      !(
                        profile.role === Role.ADMIN ||
                        (profile.role === Role.ENG &&
                          profile.emissoras?.some(
                            (e: { sigla: string }) => e.sigla === 'CUR',
                          ))
                      )
                    }
                    fill
                    color="font"
                    size="xsm"
                    round
                    tooltip="DESVINCULAR MÍDIA"
                    onClick={() =>
                      handleDesvinculaMidia(historico.comercial.id)
                    }
                  >
                    <FiVideoOff />
                  </Button>
                ) : !!mxfFile && mxfFile.length > 0 ? (
                  <ProgressBar
                    completed={uploadProgress}
                    bgColor={themeContext?.button.primary.out}
                    width="100px"
                  />
                ) : (
                  <Button
                    disabled={loading}
                    fill
                    color="font"
                    size="xsm"
                    round
                    tooltip="UPLOAD MANUAL"
                    onClick={() => handleUpload(historico.comercial.id)}
                  >
                    <FiUploadCloud />
                  </Button>
                )}
              </GeneralDataHeader>

              <ul>
                <li>
                  <p>Loudness:</p>
                  <Field
                    loading={loading}
                    value={`${historico.midiainfo?.midiainfo8ch?.loudness
                      .value ?? '--'} LUFS / ${historico.midiainfo?.midiainfo
                      ?.loudness.value ?? '--'} LUFS`}
                    tag="strong"
                    height={25}
                  />
                </li>
                <li>
                  <p>Status Baixa:</p>
                  <Field
                    loading={loading}
                    height={25}
                    tag="strong"
                    value={
                      historico.midia?.statusbaixa ? (
                        <Flag
                          type={historico.midia?.statusbaixa}
                          name={historico.midia?.statusbaixa}
                          handleAction={() =>
                            handlePlayer(historico.midia?.preview_url)
                          }
                          handleAction2={() =>
                            historico.midia &&
                            historico.midia.preview_url &&
                            copyToClipboard(historico.midia.preview_url)
                          }
                          icon={<FiPlay />}
                          icon2={<FiLink />}
                        />
                      ) : (
                        undefined
                      )
                    }
                  />
                </li>
                <li>
                  <p>Pré Avaliação:</p>
                  <div>
                    <Field
                      loading={loading}
                      height={25}
                      tag="strong"
                      value={
                        historico.midia?.statuspreavaliacao ? (
                          <Flag
                            type={historico.midia?.statuspreavaliacao}
                            name={`16CH-${historico.midia?.statuspreavaliacao}`}
                            handleAction={() => handleMidiaInfoDialog(true)}
                            disabledButton={
                              !historico.midiainfo ||
                              !historico.midiainfo.midiainfo
                            }
                            icon={<FiInfo />}
                          />
                        ) : (
                          undefined
                        )
                      }
                    />

                    <Field
                      loading={loading}
                      height={25}
                      tag="strong"
                      value={
                        historico.midia?.statuspreavaliacao8ch ? (
                          <Flag
                            type={historico.midia?.statuspreavaliacao8ch}
                            name={`8CH-${historico.midia?.statuspreavaliacao8ch}`}
                            handleAction={() => handleMidiaInfoDialog(false)}
                            disabledButton={
                              !historico.midiainfo ||
                              !historico.midiainfo.midiainfo8ch
                            }
                            icon={<FiInfo />}
                          />
                        ) : (
                          undefined
                        )
                      }
                    />
                  </div>
                </li>
              </ul>
            </MidiaInfo>
          </Engenharia>
          <EnviaExibidor>
            <GeneralDataHeader>
              <h3>Destinos</h3>
              <Button
                disabled={!historico.midia || !hasOperacaoRemota}
                fill
                color="font"
                size="xsm"
                round
                tooltip="OPERAÇÃO REMOTA"
                onClick={() => handleOperacaoRemota()}
              >
                <FiGitMerge />
              </Button>
            </GeneralDataHeader>
            <Table>
              <thead>
                <tr>
                  <th>EXIBIDORA</th>
                  <th>STATUS</th>
                  <th>CONFERIDO</th>
                  <th>AUTORIZADO EM</th>
                </tr>
              </thead>

              <tbody>
                {!!historico?.envios &&
                  historico.envios.length > 0 &&
                  historico.envios.map(envio => (
                    <tr key={envio.id}>
                      <td>
                        <h4>{envio.emissora.nome}</h4>
                        {envio.emissoraorigem && (
                          <div id={`id_emissoraorigem${envio.id}`}>
                            <h4>({envio.emissoraorigem.nome})</h4>
                            <Tooltip
                              target={`id_emissoraorigem${envio.id}`}
                              position="right"
                            >
                              OPERAÇÃO REMOTA
                            </Tooltip>
                          </div>
                        )}
                      </td>
                      <td>
                        <Flag
                          type={envio.statusgeral.type}
                          name={envio.statusgeral.nome}
                          tooltip={envio.statusgeral.info}
                        />
                      </td>
                      <td>
                        <Avatar
                          size="30"
                          name={envio.usuarioconferencia?.nome}
                          src={envio.usuarioconferencia?.avatar_url}
                          round
                        />
                      </td>
                      <td>{envio.formatted_allowed_at}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </EnviaExibidor>
        </GeneralData>
        <TimelineData>
          <h3>Timeline</h3>
          <Timeline
            height="auto"
            data={historico?.timeline}
            comercialId={historico.comercial.id}
            layout="1-column"
            padding="15px 0 0 0"
          />
        </TimelineData>
      </Content>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
};

export default Historico;
